import React from 'react';
import SpeakerHeadshot from '../ui-components/SpeakerHeadshot.jsx';
import { getFormattedSpeakerName } from '../utils/helpers.js';

const SpeakerCard = ({ speaker, onSpeakerClick, visibleSpeakerFields = [] }) => {
  const handleClick = () => {
    if (onSpeakerClick && speaker.id) {
      onSpeakerClick(speaker.id);
    }
  };
  return (
    <div
      className="schedule-itinerary__speaker-card"
      onClick={handleClick}
      style={{ cursor: onSpeakerClick ? 'pointer' : 'default' }}
    >
      <SpeakerHeadshot speaker={speaker} />
      <div className="schedule-itinerary__speaker-info">
        <h4 className="schedule-itinerary__speaker-name">
          {getFormattedSpeakerName(
            visibleSpeakerFields.includes('salutation') ? speaker?.salutation : '',
            speaker?.full_name,
            visibleSpeakerFields.includes('honorific') ? speaker?.honorific : ''
          )}
        </h4>
        <div className="schedule-itinerary__speaker-details">
          <p className="schedule-itinerary__speaker-title">{speaker?.title}</p>
          <p className="schedule-itinerary__speaker-company">{speaker?.company_name}</p>
        </div>
      </div>
    </div>
  );
};

export default SpeakerCard;
